var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegistration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 464,
    viewBox: "0 0 580 464",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M545.293 55.4581H256.133C243.828 55.4581 233.867 65.4191 233.867 77.7238V462.274H567.5V77.6652C567.559 65.4191 557.598 55.4581 545.293 55.4581Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M545.117 55.4581H256.25C243.887 55.4581 233.867 65.4777 233.867 77.8409V94.3644H567.5V77.8409C567.559 65.4777 557.48 55.4581 545.117 55.4581Z",
    fill: "#FF5D0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M545.293 55.4581H256.133C243.828 55.4581 233.867 65.4191 233.867 77.7238V462.274H567.5V77.6652C567.559 65.4191 557.598 55.4581 545.293 55.4581Z",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M262.227 79.3622C265.624 79.3622 268.379 76.6077 268.379 73.2098C268.379 69.812 265.624 67.0575 262.227 67.0575C258.829 67.0575 256.074 69.812 256.074 73.2098C256.074 76.6077 258.829 79.3622 262.227 79.3622Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M284.666 79.3622C288.064 79.3622 290.818 76.6077 290.818 73.2098C290.818 69.812 288.064 67.0575 284.666 67.0575C281.268 67.0575 278.514 69.812 278.514 73.2098C278.514 76.6077 281.268 79.3622 284.666 79.3622Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M307.053 79.3622C310.451 79.3622 313.205 76.6077 313.205 73.2098C313.205 69.812 310.451 67.0575 307.053 67.0575C303.655 67.0575 300.9 69.812 300.9 73.2098C300.9 76.6077 303.655 79.3622 307.053 79.3622Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M516.525 66.9984H327.854V79.3617H516.525V66.9984Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4074 201.315L97.9648 205.873L102.522 201.315L97.9648 196.758L93.4074 201.315Z",
    fill: "#FF5D0E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.426 98.3408L132.975 111.889L146.523 98.3408L132.975 84.7926L119.426 98.3408Z",
    fill: "#FF5D0E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0528 130.731L39.582 140.26L49.1113 130.731L39.582 121.201L30.0528 130.731Z",
    fill: "#FF5D0E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M378.059 229.565H409.641V175.952H378.059V229.565Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M378.059 231.958H409.641V175.942H378.059V231.958Z",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M427.988 37.9381C427.988 37.9381 407.715 24.6373 420.488 9.6959C441.816 -15.265 468.477 24.9303 468.477 24.9303C468.477 24.9303 501.641 31.4342 483.066 66.5318C483.066 66.5318 508.965 72.6842 497.715 107.372C486.465 142.059 416.504 100.751 416.504 100.751C416.504 100.751 403.731 87.3912 421.719 65.5357L427.988 37.9381Z",
    fill: "#0A0A0A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M427.988 37.9381C427.988 37.9381 407.715 24.6373 420.488 9.6959C441.816 -15.265 468.477 24.9303 468.477 24.9303C468.477 24.9303 501.641 31.4342 483.066 66.5318C483.066 66.5318 508.965 72.6842 497.715 107.372C486.465 142.059 416.504 100.751 416.504 100.751C416.504 100.751 403.731 87.3912 421.719 65.5357L427.988 37.9381Z",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M503.75 102.038L466.602 92.5459H434.258L399.453 102.331V231.003H508.262L503.75 102.038Z",
    fill: "#FF5D0E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M422.196 127.005C425.404 116.819 419.747 105.962 409.562 102.754C399.376 99.5458 388.518 105.202 385.31 115.388C382.103 125.573 387.759 136.431 397.945 139.639C408.13 142.847 418.988 137.19 422.196 127.005Z",
    fill: "#FF5D0E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M386.445 112.585L365.527 143.112L389.961 167.956L418.379 133.796L386.445 112.585Z",
    fill: "#0DC9C9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M439.416 122.607L455.061 112.646C462.326 108.017 466.662 100.048 466.662 91.4933V66.4738H438.596L439.416 122.607Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M439.416 122.607L455.061 112.646C462.326 108.017 466.662 100.048 466.662 91.4933V66.4738H438.596L439.416 122.607Z",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M427.578 38.7588C427.578 38.7588 418.613 57.3916 422.832 72.8603C427.051 88.3291 450.43 80.4189 450.43 80.4189L458.398 74.6767L466.25 68.9931C466.25 68.9931 477.148 51.7666 469.238 38.7588C461.387 25.6924 436.191 20.5947 427.578 38.7588Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M450.488 80.4175C450.488 80.4175 427.109 88.3276 422.891 72.8589C418.672 57.3901 427.637 38.7573 427.637 38.7573C436.25 20.6519 461.387 25.7495 469.355 38.7573C477.266 51.7651 466.719 68.4058 466.719 68.4058L466.777 71.3355",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M427.987 37.9387C430.741 42.3919 440.351 38.8176 450.604 35.3606C450.604 35.3606 452.362 45.263 462.147 45.9075L466.601 66.4153C466.601 66.4153 480.487 68.4661 478.495 55.2825C476.503 42.0989 473.515 32.8997 461.62 26.1028C449.726 19.3059 426.522 23.6419 426.522 23.6419C426.522 23.6419 424.413 32.138 427.987 37.9387Z",
    fill: "#0A0A0A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M427.99 37.9358C431.975 41.3928 440.354 38.8147 450.607 35.3577C450.607 35.3577 452.365 45.26 462.15 45.9045L466.604 66.4124",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M459.041 56.5704C459.041 56.5704 465.252 47.9571 469.822 48.9532C474.393 49.9493 475.271 60.672 473.514 65.711C471.756 70.7501 460.74 64.6563 460.74 64.6563L459.041 56.5704Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M459.041 56.5704C459.041 56.5704 465.252 47.9571 469.822 48.9532C474.393 49.9493 475.271 60.672 473.514 65.711C471.756 70.7501 460.74 64.6563 460.74 64.6563",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M365.701 115.692L368.807 112.587C368.865 112.528 368.865 112.528 368.924 112.47L369.041 112.353C370.271 111.181 371.912 110.478 373.729 110.478H417.439C420.662 110.478 423.357 112.821 423.826 115.985L433.611 183.72C433.904 185.653 433.318 187.47 432.205 188.876C431.854 189.286 431.502 189.696 431.092 189.989L427.693 193.388L427.049 191.454C426.99 191.454 426.932 191.454 426.873 191.454H383.162C379.939 191.454 377.244 189.11 376.775 185.946L366.99 118.212L365.701 115.692Z",
    fill: "#D5D5D5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M368.984 112.353C370.215 111.181 371.855 110.478 373.672 110.478H417.383C420.605 110.478 423.301 112.821 423.77 115.985L433.555 183.72C433.848 185.653 433.262 187.47 432.148 188.876",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M379.765 194.908H423.476C427.636 194.908 430.801 191.217 430.215 187.115L420.429 119.381C419.961 116.217 417.265 113.873 414.043 113.873H370.332C366.172 113.873 363.008 117.565 363.593 121.666L373.379 189.401C373.847 192.565 376.543 194.908 379.765 194.908Z",
    fill: "#0A0A0A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M379.765 194.908H423.476C427.636 194.908 430.801 191.217 430.215 187.115L420.429 119.381C419.961 116.217 417.265 113.873 414.043 113.873H370.332C366.172 113.873 363.008 117.565 363.593 121.666L373.379 189.401C373.847 192.565 376.543 194.908 379.765 194.908Z",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M516.596 132.491C522.848 123.833 520.896 111.746 512.238 105.495C503.579 99.2432 491.493 101.194 485.241 109.853C478.99 118.511 480.941 130.598 489.599 136.85C498.258 143.101 510.345 141.15 516.596 132.491Z",
    fill: "#FF5D0E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M518.166 112.585L537.619 166.55L500.881 177.214L483.068 128.698L518.166 112.585Z",
    fill: "#FF5D0E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M517.931 172.233C517.931 172.233 473.399 166.784 453.595 168.015L429.513 151.14L430.743 159.519L408.243 153.366C406.896 153.015 405.431 152.897 404.024 153.249C402.149 153.659 400.509 154.714 403.79 157.292C403.79 157.292 395.646 157.292 401.739 162.624C401.739 162.624 397.521 164.382 401.388 166.843C401.388 166.843 398.692 167.663 399.806 169.89C400.157 170.651 400.802 171.237 401.563 171.589L426.114 184.187C429.981 186.179 434.2 187.468 438.595 187.937L453.478 189.636L505.978 213.894C527.892 224.03 551.095 202.526 542.657 179.909L537.735 166.608L517.931 172.233Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M517.931 172.233C517.931 172.233 473.399 166.784 453.595 168.015L429.513 151.14L430.743 159.519L408.243 153.366C406.896 153.015 405.431 152.897 404.024 153.249C402.149 153.659 400.509 154.714 403.79 157.292C403.79 157.292 395.646 157.292 401.739 162.624C401.739 162.624 397.521 164.382 401.388 166.843C401.388 166.843 398.692 167.663 399.806 169.89C400.157 170.651 400.802 171.237 401.563 171.589L426.114 184.187C429.981 186.179 434.2 187.468 438.595 187.937L453.478 189.636L505.978 213.894C527.892 224.03 551.095 202.526 542.657 179.909L537.735 166.608L517.931 172.233Z",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M528.709 178.211C528.709 178.211 522.029 171.473 511.131 171.473",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M425.059 164.264L403.73 157.233",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M401.682 162.568L423.068 169.892",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M401.328 166.785L420.488 174.812",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M537.615 166.55L532.869 153.483",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M498.301 170.124L491.094 152.897",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M399.805 155.301L396.992 160.516L391.953 155.301L395.117 149.91L399.805 155.301Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M469.295 58.3291C469.295 58.3291 466.717 60.7314 463.025 59.3252",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M438.125 51.7081C438.125 53.2902 438.887 54.5206 439.824 54.5206C440.762 54.5206 441.523 53.2316 441.523 51.7081C441.523 50.1261 440.762 48.8956 439.824 48.8956C438.828 48.8956 438.125 50.1847 438.125 51.7081Z",
    fill: "#0A0A0A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M425.938 51.7081C425.938 53.2902 426.699 54.5206 427.637 54.5206C428.574 54.5206 429.336 53.2316 429.336 51.7081C429.336 50.1261 428.574 48.8956 427.637 48.8956C426.699 48.8956 425.938 50.1847 425.938 51.7081Z",
    fill: "#0A0A0A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M446.212 45.2017C443.575 42.5064 439.415 41.8619 436.016 43.3853C435.313 43.6783 435.079 44.7916 435.489 45.3775C435.958 46.0806 436.719 46.2564 437.481 45.9048C437.305 45.9634 437.364 45.9634 437.481 45.9048C437.598 45.8463 437.657 45.8463 437.774 45.7877C437.95 45.7291 438.067 45.6705 438.243 45.6705C438.419 45.6119 438.594 45.6119 438.77 45.5533C438.829 45.5533 438.946 45.5533 439.005 45.4947C438.829 45.4947 438.887 45.4947 439.005 45.4947C439.356 45.4947 439.708 45.4361 440.059 45.4361C440.235 45.4361 440.411 45.4361 440.587 45.4947C440.704 45.4947 440.762 45.4947 440.587 45.4947C440.704 45.4947 440.762 45.5533 440.88 45.5533C441.231 45.6119 441.583 45.7291 441.876 45.8463C442.051 45.9049 442.169 45.9634 442.344 46.022C442.169 45.9634 442.227 45.9634 442.344 46.022C442.462 46.0806 442.52 46.1392 442.637 46.1392C442.93 46.315 443.223 46.4908 443.516 46.6666C443.633 46.7252 443.633 46.7252 443.516 46.6666C443.575 46.7252 443.633 46.7838 443.692 46.8423C443.868 46.9595 443.985 47.1353 444.161 47.2525C444.688 47.7798 445.684 47.8384 446.212 47.2525C446.739 46.6666 446.798 45.7877 446.212 45.2017Z",
    fill: "#0A0A0A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M429.219 43.2075C428.281 43.0903 427.402 43.0903 426.465 43.2661C425.703 43.4419 424.941 43.7935 424.238 44.2036C423.945 44.438 423.652 44.6724 423.594 45.0825C423.477 45.4341 423.535 45.9028 423.77 46.1958C423.945 46.4888 424.297 46.7817 424.648 46.8403C425 46.8989 425.469 46.8989 425.762 46.6646C426.055 46.4888 426.406 46.313 426.699 46.1372C426.582 46.1958 426.465 46.2544 426.348 46.313C426.758 46.1372 427.227 46.02 427.695 45.9614C427.578 45.9614 427.461 46.02 427.285 46.02C427.754 45.9614 428.223 45.9614 428.691 46.02C428.574 46.02 428.457 45.9614 428.281 45.9614C428.34 45.9614 428.34 45.9614 428.398 45.9614C428.809 46.02 429.16 46.02 429.512 45.7857C429.805 45.6099 430.098 45.2583 430.156 44.9067C430.215 44.5552 430.215 44.0864 429.98 43.7935C429.863 43.6177 429.57 43.2661 429.219 43.2075Z",
    fill: "#0A0A0A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M432.326 51.4721C431.916 53.3471 431.213 55.1049 430.217 56.7455C429.748 57.5072 429.279 58.0932 428.752 58.7377C428.166 59.3822 427.58 60.0268 427.17 60.7885C426.291 62.4291 426.525 64.4799 428.166 65.5346C429.455 66.3549 431.095 66.2963 432.56 66.1205C433.322 66.0033 433.791 65.0072 433.556 64.3041C433.322 63.4838 432.56 63.1908 431.74 63.308C432.092 63.2494 431.74 63.308 431.623 63.308C431.506 63.308 431.33 63.308 431.213 63.308C430.92 63.308 430.627 63.308 430.334 63.308C430.568 63.308 430.217 63.308 430.158 63.2494C430.041 63.2494 429.924 63.1908 429.806 63.1322C429.689 63.0737 429.748 63.1322 429.865 63.1322C429.806 63.1322 429.748 63.0737 429.689 63.0151C429.572 62.9565 429.455 62.8393 429.631 62.9565C429.455 62.8393 429.455 62.6635 429.513 62.4291C429.748 61.8432 430.158 61.3744 430.568 60.9057C432.736 58.3862 434.318 55.4565 435.08 52.1752C435.256 51.4135 434.845 50.5932 434.084 50.3588C433.381 50.2416 432.502 50.6518 432.326 51.4721Z",
    fill: "#0A0A0A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M437.072 68.4039C437.014 68.5797 437.014 68.7555 436.955 68.9313C436.955 68.9899 436.896 69.0485 436.896 69.1656C436.779 69.4 436.955 68.9899 436.896 69.1656C436.721 69.4586 436.603 69.7516 436.428 70.0445C436.31 70.2203 436.369 70.2203 436.428 70.0445C436.428 70.1031 436.31 70.2203 436.252 70.2789C436.135 70.3961 436.017 70.5133 435.9 70.6305C435.842 70.6891 435.783 70.7477 435.666 70.8063C435.49 70.9234 435.9 70.6891 435.724 70.8063C435.549 70.9234 435.432 70.982 435.256 71.0992C435.08 71.1578 434.963 71.275 434.787 71.3336C434.904 71.275 434.963 71.275 434.787 71.3336C434.67 71.3922 434.611 71.3922 434.494 71.4508C434.318 71.5094 434.142 71.5094 433.967 71.568C433.615 71.6266 434.142 71.568 433.967 71.568C433.849 71.568 433.791 71.568 433.674 71.568C433.498 71.568 433.322 71.568 433.146 71.568C433.029 71.568 432.912 71.568 432.853 71.568C432.971 71.6266 433.029 71.6266 432.912 71.568C432.736 71.5094 432.502 71.5094 432.326 71.4508C432.267 71.4508 432.15 71.3922 432.092 71.3922C431.74 71.275 432.326 71.5094 431.974 71.3336C431.271 71.0406 430.392 71.0992 429.982 71.8609C429.631 72.5055 429.748 73.5016 430.51 73.8531C432.502 74.732 434.728 74.7906 436.662 73.7359C438.303 72.857 439.592 71.1578 439.943 69.3414C440.119 68.5797 439.709 67.7008 438.947 67.525C438.127 67.232 437.248 67.5836 437.072 68.4039Z",
    fill: "#0A0A0A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M399.453 194.91V232",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M302.537 434.324L293.338 456.296V462.449H403.963V455.652C403.963 448.738 399.041 442.878 392.303 441.589L353.514 434.324H302.537Z",
    fill: "#FF5D0E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M293.338 456.296V462.448H403.963V455.652C403.963 455.593 403.963 455.593 403.963 455.534H293.631L293.338 456.296Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M326.617 325.165C344.933 325.165 359.781 310.317 359.781 292.001C359.781 273.685 344.933 258.837 326.617 258.837C308.301 258.837 293.453 273.685 293.453 292.001C293.453 310.317 308.301 325.165 326.617 325.165Z",
    fill: "#D5D5D5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M304.646 267.157C304.646 267.157 269.432 300.321 266.033 313.68C262.693 327.04 213.65 404.5 213.65 404.5V454.422H266.502L299.607 402.508V434.383H359.783L359.549 288.25L304.646 267.157Z",
    fill: "#D5D5D5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6074 460.28C62.9234 460.28 77.7715 445.432 77.7715 427.116C77.7715 408.8 62.9234 393.952 44.6074 393.952C26.2914 393.952 11.4434 408.8 11.4434 427.116C11.4434 445.432 26.2914 460.28 44.6074 460.28Z",
    fill: "#D5D5D5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5898 395.477C34.5898 395.477 57.207 384.52 104.316 371.102L227.598 348.602V460.282H44.6094L34.5898 395.477Z",
    fill: "#D5D5D5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M227.596 413.994L242.947 415.224C242.947 415.224 284.783 407.314 285.486 423.662C285.662 428.232 285.545 443.349 284.139 448.388C279.979 463.33 264.979 463.154 249.51 461.982L227.596 460.341V413.994Z",
    fill: "#FF5D0E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M234.803 415.166C234.803 415.166 235.74 414.99 237.381 414.756L227.537 413.994V414.638L234.803 415.166Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M285.488 423.602C285.078 414.227 271.074 412.821 259.238 413.348C268.555 413.817 277.051 416.278 277.344 423.602C277.52 428.172 277.402 443.29 275.996 448.329C273.125 458.583 265.156 461.747 255.43 462.333C268.672 462.919 280.508 461.395 284.141 448.329C285.547 443.29 285.723 428.172 285.488 423.602Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M110.762 220.809L162.09 209.266H196.074L240.254 220.926L232.988 374.793H117.676L110.762 220.809Z",
    fill: "#FF5D0E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M148.141 347.313C148.141 347.313 160.738 343.505 163.023 339.52C165.25 335.536 172.105 342.45 166.363 348.192C160.68 353.934 160.68 353.934 160.68 353.934L148.141 347.313Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M148.141 347.313C148.141 347.313 160.738 343.505 163.023 339.52C165.25 335.536 172.105 342.45 166.363 348.192C160.68 353.934 160.68 353.934 160.68 353.934L148.141 347.313Z",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M232.986 267.156C246.06 267.156 256.658 256.558 256.658 243.485C256.658 230.411 246.06 219.813 232.986 219.813C219.913 219.813 209.314 230.411 209.314 243.485C209.314 256.558 219.913 267.156 232.986 267.156Z",
    fill: "#FF5D0E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M117.674 267.156C130.747 267.156 141.346 256.558 141.346 243.485C141.346 230.411 130.747 219.813 117.674 219.813C104.6 219.813 94.002 230.411 94.002 243.485C94.002 256.558 104.6 267.156 117.674 267.156Z",
    fill: "#FF5D0E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2266 231.531L65.1172 277.469L105.078 302.313L137.188 256.903L97.2266 231.531Z",
    fill: "#FF5D0E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1165 277.471L53.4564 294.229C39.5696 314.151 45.0775 341.69 65.6439 354.698L103.144 378.369C107.714 381.24 112.988 382.764 118.437 382.764H127.46L139.296 379.248L158.515 386.924C158.515 386.924 163.027 386.104 162.089 382.178C162.089 382.178 167.421 381.709 166.718 376.905C166.718 376.905 169.648 374.502 168.827 371.162C168.827 371.162 172.167 369.463 171.23 365.127C170.292 360.791 156.699 349.248 148.144 347.315L125.527 346.553L97.3431 314.209L105.077 302.373L65.1165 277.471Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1165 277.471L53.4564 294.229C39.5696 314.151 45.0775 341.69 65.6439 354.698L103.144 378.369C107.714 381.24 112.988 382.764 118.437 382.764H127.46L139.296 379.248L158.515 386.924C158.515 386.924 163.027 386.104 162.089 382.178C162.089 382.178 167.421 381.709 166.718 376.905C166.718 376.905 169.648 374.502 168.827 371.162C168.827 371.162 172.167 369.463 171.23 365.127C170.292 360.791 156.699 349.248 148.144 347.315L125.527 346.553L97.3431 314.209L105.077 302.373L65.1165 277.471Z",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5684 316.727L92.9473 309.344",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M162.088 382.117L153.064 373.797L140.291 367.469",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M166.365 377.781L156.932 367.059L143.162 359.852",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M168.826 371.103L161.443 362.724L147.967 354.404",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M254.844 234.988L277.578 288.191L233.867 299.851L210.371 250.457L254.844 234.988Z",
    fill: "#FF5D0E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M233.867 299.853L239.258 318.661H284.141V309.286L277.578 288.193L233.867 299.853Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M233.867 299.853L239.258 318.661H284.141V309.286L277.578 288.193L233.867 299.853Z",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M273.357 391.377L297.381 321.827C298.787 317.842 295.799 313.682 291.58 313.682H186.639C185.467 313.682 184.471 314.444 184.119 315.557L158.748 395.069H125.174C123.943 395.069 122.947 396.065 122.947 397.295C122.947 398.526 123.768 398.995 123.943 399.522H254.08C267.088 399.463 271.658 396.241 273.357 391.377Z",
    fill: "#0A0A0A"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M159.1 394.014L184.061 315.499C184.412 314.444 185.408 313.682 186.521 313.682C188.279 313.682 189.51 315.381 188.982 317.081L163.084 396.827C162.557 398.409 161.092 399.463 159.451 399.463H125.291C124.061 399.463 123.064 398.467 123.064 397.237C123.064 396.006 124.061 395.01 125.291 395.01H157.752C158.279 395.069 158.865 394.6 159.1 394.014Z",
    fill: "#D5D5D5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M186.463 313.682C185.35 313.682 184.354 314.385 184.002 315.499L159.041 394.014C158.865 394.659 158.279 395.069 157.635 395.069H125.174C123.943 395.069 122.947 396.065 122.947 397.295C122.947 398.526 123.943 399.522 125.174 399.522H228.533",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M226.6 358.331L231.58 367.706L240.604 358.331L234.92 348.721L226.6 358.331Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M299.607 311.335V413.288V434.323H359.783",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M182.945 236.629H175.68C167.242 236.629 160.445 229.833 160.445 221.395V181.024H198.18V221.395C198.18 229.833 191.324 236.629 182.945 236.629Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M182.945 236.629H175.68C167.242 236.629 160.445 229.833 160.445 221.395V181.024H198.18V221.395C198.18 229.833 191.324 236.629 182.945 236.629Z",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M196.834 149.149C196.834 149.149 223.963 175.985 210.076 200.125C196.248 224.266 159.802 192.743 159.802 192.743C159.802 192.743 144.685 160.34 151.775 149.149C158.806 137.958 185.056 132.801 196.834 149.149Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M159.802 192.743C159.802 192.743 144.685 160.34 151.775 149.149C158.865 137.958 185.056 132.801 196.892 149.149C196.892 149.149 224.021 175.985 210.134 200.125C203.806 211.2 192.732 210.555 182.595 206.688",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M162.088 157.703C162.088 157.703 196.249 163.914 206.268 147.977C216.288 132.039 201.581 120.848 176.795 124.422C152.069 127.938 143.514 130.047 139.647 143.289C139.647 143.289 126.698 139.481 129.041 152.137C131.385 164.793 135.37 188.407 159.745 192.801L156.463 169.246C156.463 169.188 163.553 164.442 162.088 157.703Z",
    fill: "#0A0A0A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M162.088 157.703C162.088 157.703 196.249 163.914 206.268 147.977C216.288 132.039 201.581 120.848 176.795 124.422C152.069 127.938 143.514 130.047 139.647 143.289C139.647 143.289 126.698 139.481 129.041 152.137C131.385 164.793 135.37 188.407 159.745 192.801L156.463 169.246C156.463 169.188 163.553 164.442 162.088 157.703Z",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M161.501 171.826C161.501 171.826 147.38 162.685 145.27 167.431C142.633 173.408 145.798 181.259 151.188 184.541C156.93 188.056 162.79 182.841 162.79 182.841L161.501 171.826Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M161.501 171.826C161.501 171.826 147.38 162.685 145.27 167.431C142.633 173.408 145.798 181.259 151.188 184.541C156.93 188.056 162.79 182.841 162.79 182.841",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M144.744 399.462H96.2285",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M227.596 460.282V399.462",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M151.07 175.281C151.07 175.281 153.473 177.801 158.219 177.039",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M187.4 171.237C187.928 173.463 187.342 175.456 186.053 175.748C184.763 176.041 183.357 174.518 182.83 172.291C182.303 170.065 182.888 168.073 184.178 167.78C185.408 167.487 186.873 169.069 187.4 171.237Z",
    fill: "#0A0A0A"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M204.51 167.431C205.037 169.658 204.451 171.65 203.162 171.943C201.873 172.236 200.467 170.712 199.939 168.486C199.412 166.259 199.998 164.267 201.287 163.974C202.517 163.681 203.982 165.205 204.51 167.431Z",
    fill: "#0A0A0A"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M174.92 166.785C174.92 166.785 179.549 161.336 187.576 162.449",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M205.447 160.046C205.447 160.046 200.525 158.757 197.186 160.046",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M195.073 171.943C196.831 173.525 198.765 175.049 200.405 176.748C201.05 177.393 201.694 178.154 201.87 179.033C202.046 179.736 201.577 180.498 201.05 181.084C200.581 181.728 200.464 182.549 201.05 183.135C201.577 183.662 202.632 183.779 203.101 183.135C203.98 182.021 204.8 180.791 204.8 179.326C204.8 177.861 204.038 176.572 203.159 175.518C202.339 174.521 201.401 173.643 200.405 172.822C199.292 171.826 198.179 170.83 197.065 169.834C196.479 169.307 195.601 169.248 195.015 169.834C194.546 170.42 194.487 171.416 195.073 171.943Z",
    fill: "#0A0A0A"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M190.795 189.458C192.846 192.504 195.952 194.848 199.76 195.141C200.522 195.2 201.284 194.438 201.225 193.676C201.167 192.856 200.581 192.27 199.76 192.212C199.643 192.212 199.585 192.212 199.467 192.212C199.233 192.094 199.292 192.212 199.467 192.212C199.35 192.153 199.116 192.153 198.999 192.153C198.647 192.094 198.354 191.977 198.002 191.86C197.827 191.801 197.651 191.743 197.475 191.684C197.651 191.743 197.651 191.743 197.475 191.684C197.417 191.626 197.299 191.626 197.241 191.567C196.889 191.391 196.596 191.215 196.303 191.04C196.127 190.922 196.01 190.864 195.893 190.747C195.835 190.747 195.6 190.512 195.776 190.629C195.952 190.747 195.659 190.512 195.659 190.512C195.366 190.278 195.073 189.985 194.78 189.751C194.487 189.458 194.252 189.165 193.96 188.872C193.96 188.872 193.725 188.579 193.842 188.696C193.96 188.813 193.725 188.52 193.725 188.52C193.608 188.344 193.491 188.169 193.374 187.993C192.963 187.348 192.085 186.997 191.381 187.465C190.678 187.876 190.327 188.813 190.795 189.458Z",
    fill: "#0A0A0A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1172 277.47L78.9453 257.724",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M105.076 302.313L123.006 277.001",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M233.865 299.852L224.139 279.461",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M277.576 288.194L270.486 271.612",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30469 462.448H577.695",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M267.559 232H547.578",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M393.828 322.763H537.617",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M393.828 354.403H537.617",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M393.828 386.044H537.617",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M393.828 417.625H466.719",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M474.395 286.257H402.5C397.695 286.257 393.828 282.39 393.828 277.585V265.573C393.828 260.768 397.695 256.901 402.5 256.901H474.395C479.199 256.901 483.066 260.768 483.066 265.573V277.585C483.066 282.39 479.199 286.257 474.395 286.257Z",
    fill: "#FF5D0E"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M315.312 201.295H283.086C268.203 201.295 256.133 189.225 256.133 174.342V142.115C256.133 127.233 268.203 115.162 283.086 115.162H315.312C330.195 115.162 342.266 127.233 342.266 142.115V174.342C342.266 189.225 330.195 201.295 315.312 201.295Z",
    fill: "#0A0A0A"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M282.326 148.855L272.951 158.23L282.326 167.605",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M316.078 148.855L325.453 158.23L316.078 167.605",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M292.814 141.529L306.057 174.986",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/Registration.e7ba551a125424a39c8e3eaf1d8f7cbb.svg";
export { ForwardRef as ReactComponent };